<template>
  <span>
    <div class="container">
      <div class="row position-relative" v-bind:style="width > 1024 ? 'padding-bottom: 200px' : 'padding-bottom: 30px'">
        <div class="col-lg-5 col-md-12 font-weight-normal pl-0 pl-lg-3" style="z-index: 1;">
              <h1 v-bind:class="['title dark-grey roboto-style xs_marginb', {'mb-5': width > 992}]">How we work</h1>
              <div role="tablist" class="medium-grey">
                <p role="tab" class="description inter-style" v-b-toggle.accordion-1>1. Understanding your business</p>
                <b-collapse id="accordion-1" v-model="collapse1" visible accordion="my-accordion" role="tabpanel">
                  <div class="row">
                    <div v-if="width < 992" class="col-lg-4 col-md-3 col-4 mb-2"><img  class="img-fluid" src="../assets/howwework1.png"/></div>
                    <p v-bind:class="['small-description inter-style col-lg-12 col-8', {'p-0' : width < 1020}]">Everything starts with getting to know your needs and more than that understanding your internal processes. Even if you are a big corporation with rigid structures and procedures, we are sharp to deliver fast and efficiently. And for your SLAs and SLOs, don’t worry, we have experience in honoring rigorous requests and reaching high-standard goals. This is why big clients prefer to work with us.</p>
                  </div>
                </b-collapse>
                <p role="tab" v-b-toggle.accordion-2 class="description inter-style">2. Keeping you on track</p>
                <b-collapse id="accordion-2" visible v-model="collapse2" accordion="my-accordion" role="tabpanel">
                  <div class="row" >
                    <div v-if="width < 992" class="col-lg-4 col-md-3 col-4 mb-3"><img  class="img-fluid" style="max-height: 300px" src="../assets/howwework3.png"/></div>
                  <p v-bind:class="['small-description inter-style col-lg-12 col-8', {'p-0' : width < 1020}]">A crucial step present throughout the process, that will give you access to regular meetings, a dedicated project manager and a team always a call, or email away. Thanks to a very efficient organization and lots of passion on our part. We also believe in transparency. Therefore, you can track the progress of implementation through Jira real-time.  </p>
                </div>
                </b-collapse>
                <p role="tab" v-b-toggle.accordion-3 class="description inter-style">3. Agile development</p>
                <b-collapse id="accordion-3" visible v-model="collapse3" accordion="my-accordion" role="tabpanel">
                  <div class="row" >
                    <div v-if="width < 992" class="col-lg-4 col-md-3 col-4 mb-3"><img  class="img-fluid" style="max-height: 300px" src="../assets/howwework2.png"/></div>
                  <p v-bind:class="['small-description inter-style col-lg-12 col-8', {'p-0' : width < 1020}]">In this phase, we use industry-endorsed standards, secure coding, and a demo environment to deliver a one of a kind product for your business. All this within your tight SLOs. Our team follows the Scrum methodology, which has proven to offer a practical framework for the collaboration of all stakeholders, even on complex products. Scrum allows you to be flexible and have the software delivered in iterative steps.</p>
                  </div>
                </b-collapse>
                <p role="tab" v-b-toggle.accordion-4 class="description inter-style">4. Continuous monitoring</p>
                <b-collapse id="accordion-4" visible v-model="collapse4" accordion="my-accordion" role="tabpanel">
                  <div class="row" >
                    <div v-if="width <= 992" class="col-lg-4 col-md-3 col-4 mb-3"><img  class="img-fluid" style="max-height: 300px" src="../assets/howwework4.png"/></div>
                  <p v-bind:class="['small-description inter-style col-lg-12 col-8', {'p-0' : width < 1020}]">Although there is a tendency to consider monitoring just an add-on component, we treat it as a core feature in the development of any product. Together with other operational functions such as security, we consider them an essential part of the whole process. And if you develop a new app, monitoring can make a difference for your business. </p>
               </div>
                </b-collapse>
                <p role="tab" v-b-toggle.accordion-5 class="description inter-style">5. Q&A and testing</p>
                <b-collapse id="accordion-5" visible v-model="collapse5" accordion="my-accordion" role="tabpanel">
                  <div class="row" >
                    <div v-if="width < 992" class="col-lg-4 col-md-3 col-4 mb-3"><img  class="img-fluid" style="max-height: 300px" src="../assets/howwework5.png"/></div>
                  <p v-bind:class="['small-description inter-style col-lg-12 col-8', {'p-0' : width < 1020}]">Your product will run through excruciating tests before setting sail into the world. One of them is the stable staging environment–a crucial step in the process towards production. At Unknown Software, we call it Sandbox, and it offers visibility during development for all the stakeholders. Testing also includes automated testing based on scenarios and random automated testing. This way, we ensure that everything is flawless from servers to upload time.
                  </p>
                  </div>
                </b-collapse>
                <p role="tab" v-b-toggle.accordion-6 class="description inter-style">6. Successful launch</p>
                <b-collapse id="accordion-6" v-model="collapse6" visible accordion="my-accordion" role="tabpanel">
                  <div class="row" >
                    <div v-if="width < 992" class="col-lg-4 col-md-3 col-4 mb-3"><img  class="img-fluid" style="max-height: 300px" src="../assets/howwework6.png"/></div>
                  <p v-bind:class="['small-description inter-style col-lg-12 col-8', {'p-0' : width < 1020}]">This step is a critical one, and it requires much attention from our part and a careful diagnosis on the best moment to do it (whether it is at 3 am) or if there are special requirements for the launch to run smoothly depending on your core target and project specifications.
                  </p>
                  </div>
                </b-collapse>
                <p role="tab" v-b-toggle.accordion-7 class="description inter-style">7. Free support for 30 days</p>
                <b-collapse id="accordion-7" v-model="collapse7" visible accordion="my-accordion" role="tabpanel">
                  <div class="row" >
                     <div v-if="width < 992" class="col-lg-4 col-md-3 col-4 mb-3"><img  class="img-fluid" style="max-height: 300px" src="../assets/howwework7.png"/></div>
                  <p v-bind:class="['small-description inter-style col-lg-12 col-8', {'p-0' : width < 1020}]">Our job doesn’t end after launch. We have a high responsibility for the final product; therefore, we offer something unheard of in our industry - 30 days of free maintenance. This way, we make sure that your product is 100% optimized. </p>
               </div>
                </b-collapse>
                <p role="tab" v-b-toggle.accordion-8 class="description inter-style">8. 24/7 Support & Maintenance</p>
                <b-collapse id="accordion-8" v-model="collapse8" visible accordion="my-accordion" role="tabpanel">
                  <div class="row">
                    <div v-if="width < 992" class="col-lg-4 col-md-3 col-4 mb-3"><img  class="img-fluid" style="max-height: 300px" src="../assets/howwework8.png"/></div>
                  <p v-bind:class="['small-description inter-style col-lg-12 col-8', {'p-0' : width < 1020}]">You can also opt for high-standard maintenance, which assures the ongoing performance of your product through the latest updates of technologies behind the applications. Also resulting in better security. Thanks to the metric-centered results, we assure that everything is according to standards and within your SLIs. We also can offer 24/7 support.
                  </p>
                  </div>
                </b-collapse>
          </div>

        </div>
        <div v-if="width >= 992" class="col-lg-7 col-md-6 col-12 px-md-0 px-lg-3" style="z-index: 1">
          <transition name="fade" mode="out-in">
            <img key="work1" v-if="collapse1" class="img-fluid" v-bind:style="width >= 768 && width < 992 ? 'margin-left: 50%' : ''" src="../assets/howwework1.png"/>
            <img key="work2" v-if="collapse2" class="img-fluid" v-bind:style="width >= 768 && width < 992 ? 'margin-left: 50%' : ''" src="../assets/howwework3.png"/>
            <img key="work3" v-if="collapse3" class="img-fluid" v-bind:style="width >= 768 && width < 992 ? 'margin-left: 50%' : ''" src="../assets/howwework2.png"/>
            <img key="work4" v-if="collapse4" class="img-fluid" v-bind:style="width >= 768 && width < 992 ? 'margin-left: 50%' : ''" src="../assets/howwework4.png"/>
            <img key="work5" v-if="collapse5" class="img-fluid" v-bind:style="width >= 768 && width < 992 ? 'margin-left: 50%' : ''" src="../assets/howwework5.png"/>
            <img key="work6" v-if="collapse6" class="img-fluid" v-bind:style="width >= 768 && width < 992 ? 'margin-left: 50%' : ''" src="../assets/howwework6.png"/>
            <img key="work7" v-if="collapse7" class="img-fluid" v-bind:style="width >= 768 && width < 992 ? 'margin-left: 50%' : ''" src="../assets/howwework7.png"/>
            <img key="work8" v-if="collapse8" class="img-fluid" v-bind:style="width >= 768 && width < 992 ? 'margin-left: 50%' : ''" src="../assets/howwework8.png"/>
          </transition>
        </div>
        <div v-if="width > 1027" id="lightgrey-container"></div>
      </div>
    </div>
  </span>
</template>

<script>
  export default {
      data() {
          return {
              collapse1: true,
              collapse2: false,
              collapse3: false,
              collapse4: false,
              collapse5: false,
              collapse6: false,
              collapse7: false,
              collapse8: false,
              width: 0
          }
      },
      computed: {
          windowWidth: {
              get: function () {
                  return this.width;
              },
              set: function (val) {
                  this.width = val;
              }

          }
      },
      mounted() {
          this.width = window.innerWidth;
          window.addEventListener('resize', () => {
              this.windowWidth = window.innerWidth;
          });
      }
  }
</script>


<style lang="scss" scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .5s
  }

  .fade-enter,
  .fade-leave-to
    /* .fade-leave-active in <2.1.8 */

  {
    opacity: 0
  }
</style>



// WEBPACK FOOTER //
// src/components/howwework.vue